// Adjusted from https://stackoverflow.com/a/61511955/2302835
export async function waitForElement<TElement extends Element>(
  selector: string,
): Promise<TElement | null> {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector<TElement>(selector))
    }

    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        observer.disconnect()
        resolve(document.querySelector<TElement>(selector))
      }
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })
  })
}

export function canScrollRight(element: Element) {
  return element.scrollLeft + element.clientWidth < element.scrollWidth
}

// Highlights a table row element momentarily
export function highlightTableRowElement(
  tableRow: Element | null,
  options?: { duration: number },
) {
  if (!tableRow) {
    console.warn('No table row element found to highlight.')
    return
  }

  const defaultOptions = { duration: 6000 }
  const duration = options?.duration || defaultOptions.duration

  tableRow.classList.add('table-row--pulse')

  setTimeout(() => {
    tableRow.classList.remove('table-row--pulse')
  }, duration)
}
